
        
    const runtime = require("../../../node_modules/simple-nunjucks-loader/lib/cjs/runtime.js");
    
    const __nunjucks_module_dependencies__ = {};
    
    __nunjucks_module_dependencies__.templates = {};
    __nunjucks_module_dependencies__.globals = {};
    __nunjucks_module_dependencies__.extensions = {};
    __nunjucks_module_dependencies__.filters = {};
    __nunjucks_module_dependencies__.assets = {};
    
    
    
    
    
    
        
            __nunjucks_module_dependencies__.templates["issue/row.njk"] = (function() {
                function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div id=\"issue_";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"id"), env.opts.autoescape);
output += "\" class=\"trigger-backdrop milestone-issue ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"closed")) {
output += "issue_closed";
;
}
output += " ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"blocking")) {
output += "issue_blocking";
;
}
output += " draggable\" data-url=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"card_url"), env.opts.autoescape);
output += "\" data-issue data-issue-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"id"), env.opts.autoescape);
output += "\">\n    <div class=\"issue-link-container\">\n        <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"url"), env.opts.autoescape);
output += "\" target=\"_blank\">\n            ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 3, colno = 30, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "UI")),"fa_image_tag"), "UI[\"fa_image_tag\"]", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"issue_type")),"fa_icon"),{"classes": "icon issuetype-icon issuetype-" + runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"issue_type")),"type")}]))), env.opts.autoescape);
output += "\n            <span class=\"issue-number\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"issue_no"), env.opts.autoescape);
output += "</span>\n            <span class=\"issue-title\" data-dynamic-field-value data-field=\"title\" data-issue-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"title"), env.opts.autoescape);
output += "</span>\n        </a>\n        <div class=\"issue-info\">\n            ";
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"affected_items")),"builds");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("build", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n                <div class=\"issue_release\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"version"), env.opts.autoescape);
output += "</div>\n            ";
;
}
}
frame = frame.pop();
output += "\n            ";
frame = frame.push();
var t_7 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"affected_items")),"components");
if(t_7) {t_7 = runtime.fromIterator(t_7);
var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("component", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n                <div class=\"issue_component\">";
output += runtime.suppressValue(runtime.memberLookup((t_8),"version"), env.opts.autoescape);
output += "</div>\n            ";
;
}
}
frame = frame.pop();
output += "\n            <div class=\"assignee-container\">\n                <span class=\"assignee\" data-dynamic-field-value data-field=\"assigned_to\" data-issue-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"id"), env.opts.autoescape);
output += "\">";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"assigned_to") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"assigned_to")),"type") == "user")) {
output += "<span class=\"avatar medium\"><img src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"assigned_to")),"avatar_url_small"), env.opts.autoescape);
output += "\"></span>";
;
}
output += "</span>\n            </div>\n            <span class=\"attachments ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"number_of_child_issues") == 0) {
output += "hidden";
;
}
output += "\" data-dynamic-field-value data-field=\"number_of_child_issues\" data-issue-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 17, colno = 208, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "UI")),"fa_image_tag"), "UI[\"fa_image_tag\"]", context, ["tasks"]))), env.opts.autoescape);
output += "<span class=\"value\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"number_of_child_issues"), env.opts.autoescape);
output += "</span></span>\n            <span class=\"attachments ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"number_of_files") == 0) {
output += "hidden";
;
}
output += "\" data-dynamic-field-value data-field=\"number_of_files\" data-issue-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 18, colno = 194, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "UI")),"fa_image_tag"), "UI[\"fa_image_tag\"]", context, ["paperclip"]))), env.opts.autoescape);
output += "<span class=\"value\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"number_of_files"), env.opts.autoescape);
output += "</span></span>\n            <span class=\"attachments ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"number_of_comments") == 0) {
output += "hidden";
;
}
output += "\" data-dynamic-field-value data-field=\"number_of_comments\" data-issue-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 19, colno = 200, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "UI")),"fa_image_tag"), "UI[\"fa_image_tag\"]", context, ["comments",[],"far"]))), env.opts.autoescape);
output += "<span class=\"value\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"number_of_comments"), env.opts.autoescape);
output += "</span></span>\n            <span class=\"attachments ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"priority")) {
output += "hidden";
;
}
output += "\" data-dynamic-field-value data-field=\"priority-icon\" data-issue-id=\"${this.id}\">";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"priority")) {
output += "<span class=\"priority priority_";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"priority")),"itemdata"), env.opts.autoescape);
output += "\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"priority")),"name"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 20, colno = 299, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "UI")),"fa_image_tag"), "UI[\"fa_image_tag\"]", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"priority")),"icon")),"name"),{"classes": "priority-icon"},runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"priority")),"icon")),"style")]))), env.opts.autoescape);
output += "</span>";
;
}
output += "</span>\n            <span class=\"status-badge\" style=\"background-color: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"status")),"color"), env.opts.autoescape);
output += "; color: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"status")),"text_color"), env.opts.autoescape);
output += ";\" data-dynamic-field-value data-field=\"status\" data-issue-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"id"), env.opts.autoescape);
output += "\"><span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"status")),"name"), env.opts.autoescape);
output += "</span></span>\n        </div>\n        <div class=\"dropper-container\">\n            <button class=\"button icon dropper dynamic_menu_link\" type=\"button\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 24, colno = 98, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "UI")),"fa_image_tag"), "UI[\"fa_image_tag\"]", context, ["ellipsis-v"]))), env.opts.autoescape);
output += "</button>\n            <div class=\"dropdown-container dynamic_menu\" data-menu-url=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "issue")),"more_actions_url"), env.opts.autoescape);
output += "\">\n                <div class=\"list-mode\">\n                    <div class=\"list-item disabled\">\n                        <span class=\"icon\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 28, colno = 61, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "UI")),"fa_image_tag"), "UI[\"fa_image_tag\"]", context, ["spinner",{"classes": "fa-spin"}]))), env.opts.autoescape);
output += "</span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

            })();
        

        function nunjucksTemplate(ctx = {}) {
            const templateContext = {
                __nunjucks_loader_assets__: __nunjucks_module_dependencies__.assets,
                ...ctx
            };

            var nunjucks = (runtime && runtime.default || runtime)(
                {"dev":true,"jinjaCompat":false,"isAsyncTemplate":false},
                __nunjucks_module_dependencies__
            );

            if (nunjucks.isAsync()) {
                return nunjucks.renderAsync(
                    "issue/row.njk",
                    templateContext
                );
            }
        
            return nunjucks.render(
                "issue/row.njk",
                templateContext
            );
        };

        nunjucksTemplate.__nunjucks_precompiled_template__ = __nunjucks_module_dependencies__.templates["issue/row.njk"];
        nunjucksTemplate.__nunjucks_module_dependencies__ = __nunjucks_module_dependencies__;

        exports = module.exports = nunjucksTemplate;
    